import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import { getDomainOverview, getDomainSavingsChart } from './domain.sagas'
import appMode from 'helpers/getAppMode'

import * as actions from 'redux/actions/keywordSavingsOverview.actions'

function* getDomainKeywordSavingsOverviewSaga(params) {
  const { domainId, filters } = params.payload

  try {
    const state = yield select()
    if (!appMode.share) {
      yield call(agent.setToken, state.user.token)
    }

    const [overview, savingsChart] = yield all([
      call(getDomainOverview, domainId, filters),
      call(getDomainSavingsChart, domainId, filters)
    ])

    const data = {
      attributes: {
        ...overview.attributes,
        ...overview.attributes.savings,
        serpFeaturesChange: overview.attributes.serpFeatures,
        savingsChart
      }
    }

    yield put(actions.getDomainKeywordSavingsOverviewSuccess(data, domainId))
  } catch (error) {
    yield put(actions.getDomainKeywordSavingsOverviewFailure(error))
  }
}

export default function* keywordSavingsOverviewSagas() {
  yield all([
    takeLatest(actions.getDomainKeywordSavingsOverview.type, getDomainKeywordSavingsOverviewSaga)
  ])
}
